import React, {useEffect, useState} from 'react';
import {makeStyles} from '@mui/styles';
import {Card, Grid} from '@mui/material';
import {SECURITY_ROLES} from '../../../constants/SECURITY_ROLES';
import {Redirect} from 'react-router-dom';

import {DocumentMetrics, LatestDocuments} from '../components';
import {useDispatch, useSelector} from 'react-redux';
import {
  AdminUserRoleMetrics,
  CompanyMetrics,
  PendingDocuments,
  UsersMetrics
} from './components/';
import CloudAdminDocumentsHistory from './components/DocumentsHistory';
import CloudAdminTopDocumentsViewedMetrics from './components/TopViewedDocuments';
import CloudAdminIpMetrics from './components/IpMetrics/CloudAdminIpMetrics';
import LoadingSpinner from "../../../components/Spinner/loading.spinner";
import {dashboardActions} from "../../../store/actions";
import GitlabMetrics from "../components/GitlabMetrics";
import buildGridItem from '../../../common/buildGridItems';

const useStyles = makeStyles(theme => ({
  root: {}
}));

const AdminDashboard = () => {
  const classes = useStyles();
  const user = useSelector(state => state.authentication.user);
  const {metrics, requestPending, nextRequest} = useSelector(state => state.dashboard);
  const [initialLoad, setInitialLoad] = useState(true);
  const [awaitingDispatch, setAwaitingDispatch] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user && !requestPending) {
      const waitTime = initialLoad ? 0 : nextRequest - Date.now();
      let thisDispatch = dispatch(dashboardActions.getCloudAdminDashboardMetrics(waitTime));
      setAwaitingDispatch(thisDispatch);
      setInitialLoad(false);
    }
  }, [user, dispatch, initialLoad, metrics, requestPending, nextRequest]);

  useEffect(() => {
    return function cleanup() {
      if (awaitingDispatch && awaitingDispatch.cancel) awaitingDispatch.cancel();
    }
  }, [awaitingDispatch])

  return (
    <React.Fragment>
      {user && (user.role) && (user.role === SECURITY_ROLES.CLOUD_ADMIN) ?
        (
          <div className={classes.root}>
            <Grid
              container
              spacing={3}
            >
              {buildGridItem(metrics, (<PendingDocuments metrics={metrics}/>), 'Pending Multimedia', {xl: 4,lg: 4,md: 4,sm: 4, xs: 12})}
              {buildGridItem(metrics, (<CompanyMetrics metrics={metrics}/>), 'Company Metrics', {xl: 4,lg: 4,md: 4,sm: 4, xs: 12})}
              {buildGridItem(metrics, (<UsersMetrics userData={metrics}/>), 'User Metrics', {xl: 4,lg: 4,md: 4,sm: 4, xs: 12})}
              {buildGridItem(metrics, (<AdminUserRoleMetrics metrics={metrics}/>), 'Role Metrics', {xl: 4,lg: 4,md: 6,sm: 12, xs: 12})}
              {buildGridItem(metrics, (<DocumentMetrics metrics={metrics} view={SECURITY_ROLES.CLOUD_ADMIN}/>), 'Admin Document Metrics', {xl: 4,lg: 4,md: 6,sm: 6, xs: 12})}
              {buildGridItem(metrics, (<CloudAdminTopDocumentsViewedMetrics metrics={metrics}/>), 'Top Multimedia Metrics', {xl: 4,lg: 4,md: 12,sm: 12, xs: 12})}
              {buildGridItem(metrics, (<CloudAdminDocumentsHistory metrics={metrics}/>), 'Multimedia History', {xl: 12,lg: 12,md: 12,sm: 12, xs: 12})}
              {buildGridItem(metrics, (<LatestDocuments metrics={metrics}/>), 'Latest Multimedia', {xl: 12,lg: 12,md: 12,sm: 12, xs: 12})}
              {buildGridItem(metrics, (<CloudAdminIpMetrics metrics={metrics}/>), 'Access Metrics', {xl: 12,lg: 12,md: 12,sm: 12, xs: 12})}
              {buildGridItem(metrics, (<GitlabMetrics/>), 'Gitlab Metrics', {xl: 12,lg: 12,md: 12,sm: 12, xs: 12})}
            </Grid>
          </div>)
        :
        (<Redirect to="/"/>)
      }
    </React.Fragment>
  );
}

export default AdminDashboard;
